import './styles.scss'

import React, { useRef } from 'react'
import { useActions, useValues, useMountedLogic } from 'kea'
import { useSelector } from 'react-redux'
import Modal from 'react-responsive-modal'

import stringWithWBR from 'lib/tags/string-with-wbr'
import FloatingHeader from 'lib/components/floating-header'
import GoodFit from 'lib/components/good-fit'
import railsContext from 'lib/selectors/rails-context'
import Helmet from 'lib/tags/helmet'

import Breadcrumbs from './breadcrumbs'
import ProfileHeader from '../../shared/profile/profile-header'
import Price from './price'
import CourseDetails from './course-details'
import Locations from './locations'
import GeneralInfo from './general-info'
import AboutTeacher from './about-teacher'
import Reviews from '../../shared/profile/reviews'
import OtherCourses from '../../shared/profile/other-courses'
import TopFloat from './top-float'
import Question from './question'
import Booking from './booking'
import SharingMenu from './sharing-menu'
import Reputation from '~/scenes/shared/reputation'
import Share from './share'
import Friends from '../../shared/profile/friends'
import BottomFloat from './bottom-float'
import SimilarCourses from './similar-courses'
import MobileBreadcrumb from './mobile-breadcrumb'

import courseLogic from '~/scenes/course/show/logic'
import sceneSaga from '~/scenes/course/show/saga'

export default function Show () {
  const {
    featureFlags: { isAdminUser },
    dpr
  } = useSelector(railsContext)
  const { openModal, translateReview, loadMore } = useActions(courseLogic)
  const { course, userData, isShareVisible, video, isOpenModal, helmet, translating, isLoading, avatar } =
    useValues(courseLogic)
  useMountedLogic(sceneSaga)

  const { title, similarCourses, reputation, facebookFriends, messageUrl } = course

  const teacherVideo = !video ? {} : video

  const modalRef = useRef()

  return (
    <>
      {helmet && <Helmet helmet={helmet} />}
      <div className='course-show-scene'>
        <FloatingHeader fromTop={319} minWidth={-1}>
          <TopFloat />
        </FloatingHeader>
        <div className='over-659'>
          <Breadcrumbs />
        </div>
        {isShareVisible && <SharingMenu />}
        <div className='tightrow'>
          <div className={`eight columns ${isAdminUser && 'padding-when-responsive'}`}>
            <ProfileHeader user={userData} course={course} video={teacherVideo} avatar={avatar} />

            <div id='course_info' className='widget nospace2'>
              <div className='coursebox'>
                <div className='course_title_container'>
                  <div id='course_price'>
                    <Price />
                  </div>
                  <h1 id='course_title' className='play-with-lines'>
                    {stringWithWBR(title)}
                  </h1>
                </div>
              </div>

              <div className='undercoursebox'>
                <CourseDetails />
                <Locations />
                <GeneralInfo />
              </div>
            </div>

            <AboutTeacher />

            {course.reviews.count > 0 && (
              <Reviews
                loadMore={loadMore}
                isLoading={isLoading}
                reviews={course.reviews}
                translateReview={translateReview}
                translating={translating}
              />
            )}

            <OtherCourses courses={course.otherCourses} />
          </div>

          <div className='four columns profile-right'>
            <div className='not-responsive'>
              <Question />
              <Booking />
              <GoodFit mode='widget' />
            </div>
            <Reputation contentStyle={{ margin: '15px 20px 15px 20px' }} reputation={reputation} />
            <div className='only-responsive'>
              <Booking noGuarantee />
              <GoodFit mode='widget' />
            </div>
            <Share />
            <Friends facebookFriends={facebookFriends} id={userData.id} />
            <div className='upto-659'>
              <MobileBreadcrumb />
            </div>
          </div>
        </div>
        {similarCourses && similarCourses.length > 0 ? <SimilarCourses dpr={dpr} courses={similarCourses} /> : null}
        <BottomFloat />
        <div className='popup-wrapper popup-content' ref={modalRef} />
        <Modal
          onOverlayClick={() => {
            openModal()
          }}
          showCloseIcon={false}
          open={isOpenModal}
          onClose={() => {}}
          center
          classNames={{ modal: 'customModal' }}
          container={modalRef.current}
        >
          <iframe
            id='message-modal-iframe'
            src={messageUrl}
            width='720'
            height='575'
            frameBorder='no'
            title="contact teacher for the actual course's popup"
          />
        </Modal>
      </div>
    </>
  )
}
